module.exports = __webpack_public_path__ + "media/images/pages/sp-hero-106b53396ab9ac2f8e9e45d62a9e54e7.jpg";